import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import {
	analyzerError, analyzerFilters, analyzerNotFound, analyzerUpdating, isAnalyzerLoading, resetSignals, responseData,
} from "Pages/AnalyzersV2/@signals"
import { createAnalyzerRequest } from "Pages/AnalyzersV2/@services/analyzerRequest"

/** The one request of DOR, LOR and Rank Analyzer (CU-869fmpqfm): one gate, so only the latest answer paints */
export const analyzerRequest = createAnalyzerRequest({
	state: { responseData, analyzerFilters, isAnalyzerLoading, analyzerUpdating, analyzerError, analyzerNotFound },
	post: payload => postSubmit("/api/dashboard/results", payload),
	resetSignals,
	onError: () => {},
	batch,
})
